module.exports = __webpack_public_path__ + "img/backgroundGlobe.84e80c80.png";